var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "autocomplete control",
      class: { "is-expanded": _vm.expanded },
    },
    [
      _vm.type === "checkbox"
        ? _c(
            "input",
            _vm._b(
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newValue,
                    expression: "newValue",
                  },
                  {
                    name: "focus-inserted",
                    rawName: "v-focus-inserted",
                    value: { focus: _vm.focusInserted },
                    expression: "{ focus: focusInserted }",
                  },
                ],
                ref: "input",
                staticClass: "input",
                class: _vm.classProp,
                attrs: {
                  size: _vm.size,
                  loading: _vm.loading,
                  rounded: _vm.rounded,
                  icon: "material-symbols-rounded",
                  "icon-right": _vm.newIconRight,
                  "icon-right-clickable": _vm.newIconRightClickable,
                  "icon-pack": _vm.iconPack,
                  maxlength: _vm.maxlength,
                  autocomplete: _vm.newAutocomplete,
                  "use-html5-validation": false,
                  "aria-autocomplete": _vm.ariaAutocomplete,
                  type: "checkbox",
                },
                domProps: {
                  checked: Array.isArray(_vm.newValue)
                    ? _vm._i(_vm.newValue, null) > -1
                    : _vm.newValue,
                },
                on: {
                  input: _vm.onInput,
                  focus: _vm.focused,
                  blur: _vm.onBlur,
                  keydown: [
                    _vm.keydown,
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp",
                        ])
                      )
                        return null
                      $event.preventDefault()
                      return _vm.keyArrows("up")
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown",
                        ])
                      )
                        return null
                      $event.preventDefault()
                      return _vm.keyArrows("down")
                    },
                  ],
                  "icon-right-click": _vm.rightIconClick,
                  "icon-click": (event) => _vm.$emit("icon-click", event),
                  change: function ($event) {
                    var $$a = _vm.newValue,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.newValue = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.newValue = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.newValue = $$c
                    }
                  },
                },
              },
              "input",
              _vm.$attrs,
              false
            )
          )
        : _vm.type === "radio"
        ? _c(
            "input",
            _vm._b(
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newValue,
                    expression: "newValue",
                  },
                  {
                    name: "focus-inserted",
                    rawName: "v-focus-inserted",
                    value: { focus: _vm.focusInserted },
                    expression: "{ focus: focusInserted }",
                  },
                ],
                ref: "input",
                staticClass: "input",
                class: _vm.classProp,
                attrs: {
                  size: _vm.size,
                  loading: _vm.loading,
                  rounded: _vm.rounded,
                  icon: "material-symbols-rounded",
                  "icon-right": _vm.newIconRight,
                  "icon-right-clickable": _vm.newIconRightClickable,
                  "icon-pack": _vm.iconPack,
                  maxlength: _vm.maxlength,
                  autocomplete: _vm.newAutocomplete,
                  "use-html5-validation": false,
                  "aria-autocomplete": _vm.ariaAutocomplete,
                  type: "radio",
                },
                domProps: { checked: _vm._q(_vm.newValue, null) },
                on: {
                  input: _vm.onInput,
                  focus: _vm.focused,
                  blur: _vm.onBlur,
                  keydown: [
                    _vm.keydown,
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp",
                        ])
                      )
                        return null
                      $event.preventDefault()
                      return _vm.keyArrows("up")
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown",
                        ])
                      )
                        return null
                      $event.preventDefault()
                      return _vm.keyArrows("down")
                    },
                  ],
                  "icon-right-click": _vm.rightIconClick,
                  "icon-click": (event) => _vm.$emit("icon-click", event),
                  change: function ($event) {
                    _vm.newValue = null
                  },
                },
              },
              "input",
              _vm.$attrs,
              false
            )
          )
        : _c(
            "input",
            _vm._b(
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newValue,
                    expression: "newValue",
                  },
                  {
                    name: "focus-inserted",
                    rawName: "v-focus-inserted",
                    value: { focus: _vm.focusInserted },
                    expression: "{ focus: focusInserted }",
                  },
                ],
                ref: "input",
                staticClass: "input",
                class: _vm.classProp,
                attrs: {
                  size: _vm.size,
                  loading: _vm.loading,
                  rounded: _vm.rounded,
                  icon: "material-symbols-rounded",
                  "icon-right": _vm.newIconRight,
                  "icon-right-clickable": _vm.newIconRightClickable,
                  "icon-pack": _vm.iconPack,
                  maxlength: _vm.maxlength,
                  autocomplete: _vm.newAutocomplete,
                  "use-html5-validation": false,
                  "aria-autocomplete": _vm.ariaAutocomplete,
                  type: _vm.type,
                },
                domProps: { value: _vm.newValue },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.newValue = $event.target.value
                    },
                    _vm.onInput,
                  ],
                  focus: _vm.focused,
                  blur: _vm.onBlur,
                  keydown: [
                    _vm.keydown,
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp",
                        ])
                      )
                        return null
                      $event.preventDefault()
                      return _vm.keyArrows("up")
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown",
                        ])
                      )
                        return null
                      $event.preventDefault()
                      return _vm.keyArrows("down")
                    },
                  ],
                  "icon-right-click": _vm.rightIconClick,
                  "icon-click": (event) => _vm.$emit("icon-click", event),
                },
              },
              "input",
              _vm.$attrs,
              false
            )
          ),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.isActive &&
                  (!_vm.isEmpty || _vm.hasEmptySlot || _vm.hasHeaderSlot),
                expression:
                  "isActive && (!isEmpty || hasEmptySlot || hasHeaderSlot)",
              },
            ],
            ref: "dropdown",
            staticClass: "dropdown-menu",
            class: { "is-opened-top": _vm.isOpenedTop && !_vm.appendToBody },
            style: _vm.style,
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isActive,
                    expression: "isActive",
                  },
                ],
                staticClass: "dropdown-content",
                style: _vm.contentStyle,
              },
              [
                _vm.hasHeaderSlot
                  ? _c(
                      "div",
                      {
                        staticClass: "dropdown-item dropdown-header",
                        class: { "is-hovered": _vm.headerHovered },
                        attrs: { role: "button", tabindex: "0" },
                        on: {
                          click: function ($event) {
                            return _vm.selectHeaderOrFoterByClick(
                              $event,
                              "header"
                            )
                          },
                        },
                      },
                      [_vm._t("header")],
                      2
                    )
                  : _vm._e(),
                _vm._l(_vm.computedData, function (element, groupindex) {
                  return [
                    element.group
                      ? _c(
                          "div",
                          {
                            key: groupindex + "group",
                            staticClass: "dropdown-item",
                          },
                          [
                            _vm.hasGroupSlot
                              ? _vm._t("group", null, {
                                  group: element.group,
                                  index: groupindex,
                                })
                              : _c(
                                  "span",
                                  { staticClass: "has-text-weight-bold" },
                                  [_vm._v(" " + _vm._s(element.group) + " ")]
                                ),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._l(element.items, function (option, index) {
                      return _c(
                        "a",
                        {
                          key: groupindex + ":" + index,
                          staticClass: "dropdown-item",
                          class: { "is-hovered": option === _vm.hovered },
                          attrs: { role: "button", tabindex: "0" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.setSelected(
                                option,
                                !_vm.keepOpen,
                                $event
                              )
                            },
                          },
                        },
                        [
                          _vm.hasDefaultSlot
                            ? _vm._t("default", null, {
                                option: option,
                                index: index,
                              })
                            : _c("span", [
                                _vm._v(
                                  " " + _vm._s(_vm.getValue(option, true)) + " "
                                ),
                              ]),
                        ],
                        2
                      )
                    }),
                  ]
                }),
                _vm.isEmpty && _vm.hasEmptySlot
                  ? _c(
                      "div",
                      { staticClass: "dropdown-item is-disabled" },
                      [_vm._t("empty")],
                      2
                    )
                  : _vm._e(),
                _vm.hasFooterSlot
                  ? _c(
                      "div",
                      {
                        staticClass: "dropdown-item dropdown-footer",
                        class: { "is-hovered": _vm.footerHovered },
                        attrs: { role: "button", tabindex: "0" },
                        on: {
                          click: function ($event) {
                            return _vm.selectHeaderOrFoterByClick(
                              $event,
                              "footer"
                            )
                          },
                        },
                      },
                      [_vm._t("footer")],
                      2
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }